// The on-brand emoji palette offered as profile icons — farm, veld, and Karoo
// flavour. Shared by the admin's Add-a-friend picker and the profile sheet.

export const EMOJIS = [
  "🍊", "🐐", "🐑", "🐄", "🐖", "🐎", "🐕", "🐇", "🦆", "🐓", "🦉", "🦊",
  "🐝", "🦋", "🐢", "🦎", "🐟", "🦅", "🌾", "🌻", "🌵", "🌱", "🌿", "🍃",
  "🌳", "🌲", "🍂", "🍄", "🌺", "🌼", "🌸", "🌈", "☀️", "🌅", "🌙", "⭐",
  "🏔️", "🏞️", "🛖", "🏡", "🚜", "🥾", "🎒", "🪣", "🧺", "🔨", "🪕", "🎸",
  "🍯", "🫖", "☕", "🥭", "🍉", "🍋", "🍓", "🫐", "🌽", "🥕", "🥔", "🍅",
  "🔥", "💧", "🌊", "🪨", "🐾", "❤️", "⚡", "🎯",
];
